import Vue from "vue";
import Vuex from "vuex";
import { ApiDatatrax, fetchWithRetry } from '@/api.service'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: "white", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
        SidebarBg: "",
        navbarColor: "primary",
        setHorizontalLayout: false, // Horizontal layout,
        profile: null,

        pub_err: {},
        publications: [],
        ratecards: [],
        ratecard_label: '',
        categories: [],
        category_perm: false,
        category_label: 'Category',
        subcategories: [],
        subcategory_label: '',
        boxsize: '450px',
        issues: [],
        acctnames: [],
        accountLabel: '',
        account_label: '',

        rates: {},
        rate_default: {},
        items: [],
        details: {},

        selected_pub: '',
        selected_ratecard: '',
        selected_acctname: '',

        selected_category: '',
        selected_subcategory: '',
        selected_issues: [],
    },
    mutations: {
        SET_SIDEBAR_DRAWER(state, payload) {
            state.Sidebar_drawer = payload;
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.Customizer_drawer = payload;
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.SidebarColor = payload;
        },
        SET_NAVBAR_COLOR(state, payload) {
            state.navbarColor = payload;
        },
        SET_LAYOUT(state, payload) {
            state.setHorizontalLayout = payload;
        },

        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_PROFILE(state, payload) {
            state.profile = payload;
        },
        SET_PUBLICATIONS_ERR(state, payload) {
            state.pub_err = {...state.pub_err, ...payload};
        },
        SET_PUBLICATIONS(state, payload) {
            state.publications = payload;
        },
        SET_CATEGORIES(state, payload) {
            state.categories = payload;
        },
        SET_CATEGORY_PERM(state, payload) {
            state.category_perm = payload;
        },
        SET_CATEGORY_LABEL(state, payload) {
            state.category_label = payload;
        },
        SET_CATEGORY_BOXSIZE(state, payload) {
            state.category_boxsize = payload;
        },
        SET_SUBCATEGORIES(state, payload) {
            state.subcategories = payload;
        },
        SET_SUBCATEGORY_LABEL(state, payload) {
            state.subcategory_label = payload;
        },
        SET_RATECARDS(state, payload) {
            state.ratecards = payload;
        },
        SET_RATECARD_LABEL(state, payload) {
            state.ratecard_label = payload;
        },
        SET_ACCTNAMES(state, payload) {
            state.acctnames = payload;
        },
        SET_ACCOUNT_LABEL(state, payload) {
            state.account_label = payload;
        },



        SET_ISSUES(state, payload) {
            state.issues = payload;
        },
        SET_RATES(state, payload) {
            state.rates = payload.rates;
            state.rate_default = payload.default;
            state.items = payload.items;
        },
      
        SET_FREQRATE(state, payload) {
            state.rate_default = payload.default;
        },
        SET_SELECTED_CATEGORY(state, payload) {
            state.selected_category = payload;
        },

        SET_SELECTED_RATECARD(state, payload) {
            state.selected_ratecard = payload;
            // console.log(payload);
        },

        SET_SELECTED_ACCTNAME(state, payload) {
            state.selected_acctname = payload;
        },
        SET_SELECTED_SUBCATEGORY(state, payload) {
            state.selected_subcategory = payload;
        },
        SET_SELECTED_PUB(state, payload) {
            state.selected_pub = payload;
        },
        SET_SELECTED_ISSUES(state, payload) {
            state.selected_issues = payload;
        },

        
    },
    actions: {
        async fetchPublications({ commit }) {
            try {
                const response = await fetchWithRetry("/api_classified/publications");
                commit('SET_PUBLICATIONS', response.data);
                if(response.data.length === 0) {
                    commit('SET_PUBLICATIONS_ERR', { pub:'No publications available. Please refresh the page.' });
                } else commit('SET_PUBLICATIONS_ERR', {pub: ''});
            } catch (error) {
                commit('SET_PUBLICATIONS_ERR', {pub: 'Error fetching publications. Please refresh the page.'});
            }
        },

        async fetchCategories({ commit }, param) {
            try {
                const response = await fetchWithRetry("/api_classified/categories?pub_code=" + param.value  + "&rate_card=" +  param.ratecard);
                const response2 = await fetchWithRetry("/api_classified/categories?pub_code=" + param.value + "&rate_card=" +  param.ratecard + "&seq_num=2");
                commit('SET_CATEGORIES', response.data);
                commit('SET_SUBCATEGORIES', response2.data);
                commit('SET_CATEGORY_PERM', response.perm);
                commit('SET_CATEGORY_BOXSIZE', response.boxsize);
                commit('SET_CATEGORY_LABEL', response.label);
                commit('SET_SUBCATEGORY_LABEL', response2.label);
                //if(response.data.length === 0) {  may not have categories until rate card selected
                //    commit('SET_PUBLICATIONS_ERR', {cat: 'No categories available. Please choose another publication.'});
                // } else commit('SET_PUBLICATIONS_ERR', {cat: ''});
            } catch (error) {
                commit('SET_PUBLICATIONS_ERR', {cat: 'Error fetching categories. Please refresh the page.'});
            }
        },

        async fetchSubCategories({ commit }, param) {
            try {
                const response2 = await fetchWithRetry("/api_classified/categories2?pub_code=" + param.value + "&rate_card=" +  param.ratecard + "&seq_num=2" + "&parent_code=" + param.parent_code);
                commit('SET_SUBCATEGORIES', response2.data);
             
            } catch (error) {
                commit('SET_PUBLICATIONS_ERR', {cat: 'Error fetching sub categories. Please refresh the page.'});
            }
        },

        async fetchIssues({ commit }, param) {
            try {
                const response = await fetchWithRetry("/api_classified/issues?pub_code=" + param.value);
                commit('SET_ISSUES', response.data);
                if(response.data.length === 0) {
                    commit('SET_PUBLICATIONS_ERR', {issue: 'No issues available. Please choose another publication.'});
                } else commit('SET_PUBLICATIONS_ERR', {issue: ''});
            } catch (error) {
                commit('SET_PUBLICATIONS_ERR', {issue: 'Error fetching issues. Please refresh the page.'});
            }
        },
        async fetchRatecards({ commit }, param) {
            try {
                const response = await fetchWithRetry("/api_classified/ratecards?pub_code=" + param.value);
                commit('SET_RATECARDS', response.data.ratecards);
                commit('SET_RATECARD_LABEL','');
                // set label to '' to hide field 
                if(Object.keys(response.data.ratecards).length === 0) {
                    commit('SET_PUBLICATIONS_ERR', {ratecard: 'Missing rate card. Please choose another publication.'});
                } else {
                    commit('SET_PUBLICATIONS_ERR', {ratecard: ''});
                    if(response.data.cnt == 1) {
                      commit('SET_RATECARD_LABEL','');
                      commit('SET_SELECTED_RATECARD',response.data.dfltcard)
  
                    }
                    else {
                      commit('SET_SELECTED_RATECARD','');
                      commit('SET_RATECARD_LABEL',response.data.label);
                    }
                    /* if one rate, just store default rate otherwise dropdown.  Blank out label if 1 */
                    
                }
            }
              catch (error) {
                commit('SET_PUBLICATIONS_ERR', {ratecard: 'Error fetching rate cards. Please refresh the page.'});
            } 
        },
        
        async fetchAccounts({ commit }, response) {
            try {
                commit('SET_ACCOUNT_LABEL','');
                // set label to '' to hide field 
                if(Object.keys(response.data.acctnames).length === 0) {
                    commit('SET_PUBLICATIONS_ERR', {acctname: 'Missing account.'});
                } else {
                    commit('SET_PUBLICATIONS_ERR', {acctname: ''});
                    if(response.data.cnt < 2) {
                      commit('SET_ACCOUNT_LABEL','');
  
                    }
                    else {
                      //console.log('down in fetchAccounts');
                      commit('SET_ACCOUNT_LABEL',response.data.accountLabel);
                      commit('SET_ACCTNAMES', response.data.acctnames);

                    }
                    
                }
            }
            catch (error) {
                commit('SET_PUBLICATIONS_ERR', {acctname: 'Error fetching accounts. Please refresh the page.'});
            } 
        },
        

        async fetchRates({ commit }, param ) {
            // console.log(param);
            try {
                const response = await fetchWithRetry("/api_classified/rates?pub_code=" + param.value + "&rate_card=" + param.ratecard + "&isscnt=" + param.isscnt);
                commit('SET_RATES', response.data);
                if(Object.keys(response.data.rates).length === 0) {
                    commit('SET_PUBLICATIONS_ERR', {rate: 'Missing rates or items. Please choose another publication.'});
                } else commit('SET_PUBLICATIONS_ERR', {rate: ''});
            } catch (error) {
                commit('SET_PUBLICATIONS_ERR', {rate: 'Missing rates or items.'});
            }
        },

        async signIn({ dispatch }, credientials) {
            let response = await ApiDatatrax.post('/login', credientials);
            return dispatch('attempt', response.token);
        },
        async fetchCurrentUser({ commit }) {
            try {
                let response = await ApiDatatrax.post('/profile')
                commit('SET_PROFILE', response.data);
                return response;
            } catch (e) {
                commit('SET_USER', null);
                commit('SET_PROFILE', null);
                commit('SET_TOKEN', null);
                return e;
            }
        },

        async attempt({ commit, state }, token) {
            if (token) {
                localStorage.setItem('id_token', token);
                commit('SET_TOKEN', token);
            }
            if (!state.token) {
                return;
            }
            try {
                let response = await ApiDatatrax.post('/profile')
                commit('SET_PROFILE', response.data);
            } catch (e) {
                commit('SET_PROFILE', null);
                commit('SET_TOKEN', null);
                console.log(e);
            }
        },
        signOut({ commit }) {
            return ApiDatatrax.post('/logout')
                .then((resp) => {
                    commit('SET_TOKEN', null);
                    commit('SET_PROFILE', null);
                    return resp;
                })
                .catch((error) => {
                    return error;
                })
        }
    },
    getters: {
        getProfile(state) {
            return state.profile;
        },
        getPublications(state) {
            return state.publications;
        },
        getPubError(state) {
            return state.pub_err;
        },
        getCategories(state) {
            return state.categories;
        },

        getRatecards(state) {
            return state.ratecards;
        },
        getRatecardLabel(state) {
            return state.ratecard_label;
        },
        getAccountLabel(state) {
            return state.account_label;
        },
        getAcctnames(state) {
            return state.acctnames;
        },
        getAcctError(state) {
            return state.acct_err;
        },

        getCategoryLabel(state) {
            return state.category_label;
        },
        getCategoryPerm(state) {
            return state.category_perm;
        },
        getSubcategories(state) {
            return state.subcategories;
        },
        getSubcategoryLabel(state) {
            return state.subcategory_label;
        },
        getBoxsize(state) {
            return state.category_boxsize;
        },
        getIssues(state) {
            return state.issues;
        },
        getRates(state) {
            return state.rates;
        },
        getItems(state) {
            return state.items;
        },
        getRateDefault(state) {
            return state.rate_default;
        },
       
        // default or selected value
        getSelectedPub(state) {
            return state.selected_pub;
        },
        getSelectedCategory(state) {
            return state.selected_category;
        },
        getSelectedRatecard(state) { 
            return state.selected_ratecard;
        },
        getSelectedAcct(state) {
            return state.selected_acctname;
        },

        getSelectedSubcategory(state) {
            return state.selected_subcategory;
        },
        getSelectedIssues(state) {
            return state.selected_issues;
        },
    },
});
